// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StreamBubble__bubble-b2a055 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: var(--message-bubble-max-width);
  padding: 0;
}

.StreamBubble__content-c1ca09 {
  position: relative;
}

.StreamBubble__status-bar-a61ff6 {
  position: absolute;
  inset-inline-end: 8px;
  bottom: 8px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  opacity: 1;
}

.StreamBubble__status-bar-a61ff6 > span {
  color: var(--addition-50);
}

.StreamBubble__status-bar-a61ff6 > svg {
  fill: var(--addition-50);
  color: var(--danger-40);
}

.StreamBubble__comment-a668d5 {
  padding: 10px 12px;
  color: var(--base-110);
}

.StreamBubble__comment-text-fbee9c {
  display: inline;
}

.StreamBubble__commented-status-bar-d19bc5 {
  float: right;
  margin-top: 2px;
  margin-inline-start: var(--indent-8px);
}

.StreamBubble__views-a40f24 span {
  color: var(--addition-50);
}

.StreamBubble__views-a40f24 svg {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/StreamBubble/StreamBubble.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,0CAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".bubble {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  max-width: var(--message-bubble-max-width);\n  padding: 0;\n}\n\n.content {\n  position: relative;\n}\n\n.status-bar {\n  position: absolute;\n  inset-inline-end: 8px;\n  bottom: 8px;\n  border-radius: 20px;\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 4px 8px;\n  opacity: 1;\n}\n\n.status-bar > span {\n  color: var(--addition-50);\n}\n\n.status-bar > svg {\n  fill: var(--addition-50);\n  color: var(--danger-40);\n}\n\n.comment {\n  padding: 10px 12px;\n  color: var(--base-110);\n}\n\n.comment-text {\n  display: inline;\n}\n\n.commented-status-bar {\n  float: right;\n  margin-top: 2px;\n  margin-inline-start: var(--indent-8px);\n}\n\n.views span {\n  color: var(--addition-50);\n}\n\n.views svg {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `StreamBubble__bubble-b2a055`,
	"content": `StreamBubble__content-c1ca09`,
	"status-bar": `StreamBubble__status-bar-a61ff6`,
	"statusBar": `StreamBubble__status-bar-a61ff6`,
	"comment": `StreamBubble__comment-a668d5`,
	"comment-text": `StreamBubble__comment-text-fbee9c`,
	"commentText": `StreamBubble__comment-text-fbee9c`,
	"commented-status-bar": `StreamBubble__commented-status-bar-d19bc5`,
	"commentedStatusBar": `StreamBubble__commented-status-bar-d19bc5`,
	"views": `StreamBubble__views-a40f24`
};
module.exports = ___CSS_LOADER_EXPORT___;
